import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import MetaTags from "react-meta-tags";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { Col, Container, Row } from "reactstrap";


import { Card, CardBody } from "reactstrap";


//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import { getTestDetail } from "store/tests/actions";

class TestDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {};
      }

  render() {
    return (
     
      
          
          <Row>

        <Col lg="12">
          
          <Card>
            <CardBody>
            <div>
            <div className="flex-grow-1 overflow-hidden">
              
              <h5 className="text-truncate font-size-24">
                {this.props.test.Title}
              </h5>
              <hr
        style={{
          background: 'black',
          color: 'black',
          borderColor: 'black',
          height: '3px',
        }}
      />
              <h3 className="text-muted font-size-10"> {this.props.test.id}</h3> 
            
            </div>
           
       
        <h5 className="font-size-15 mt-4">Test Description :</h5>
          <p className="text-muted">
            {this.props.test.Description}
          </p>
       
       
       
        <h5 className="font-size-15 mt-4">Pre Conditions</h5>
          <p className="text-muted">
          <i className="bx bx-chevron-right bx-tada"></i>
          &nbsp; {this.props.test.PreConditions}
          </p>
         
            <h5 className="font-size-15 mt-4">Lower Price Limit</h5>
          <p className="text-muted">
          <i className="bx bx-money bx-tada bx-rotate-90"></i>
          &nbsp; &nbsp;{this.props.test.LowerPriceLimit}
          </p>
          <h5 className="font-size-15 mt-4">Upper Price Limit</h5>
          <p className="text-muted">
          <i className="bx bx-money bx-tada bx-rotate-90"></i>
          &nbsp; &nbsp; {this.props.test.UpperPriceLimit}
          </p>
          <h5 className="font-size-15 mt-4">Average Duration </h5>
          <p className="text-muted">
          <i className="bx bx-time-five bx-spin bx-rotate-270"></i>
          &nbsp; &nbsp; {this.props.test.AvgDuration}
          </p>
        
            </div>
            </CardBody>
        </Card>
        </Col>
        {/* <Col lg="3">
    <Card>
        <CardBody>
        <div className="d-flex flex-wrap">
            <div>
                <h3 className="font-size-22 text-center"> Registered Tests</h3>
            </div>
                <div>
                  <p className="text-muted mb-1">Total Tests Registered</p>
                  <h4 className="mb-3 text-center">{this.props.tests.length}</h4>
                  <div className="mx-auto text-center">
                  <i className="bx bx-test-tube bx-tada bx-md"></i></div>
                  </div>
                  </div>
                  </CardBody>
                  </Card>
                  </Col> */}
                  
        </Row>
     
      
    );
  }
}

TestDetails.propTypes = {
    test: PropTypes.object,
    tests: PropTypes.array,
  };
  
export default TestDetails;
  
